import React, { useState, useEffect, useRef } from "react";
import { Input, Icon, Grid, Segment, Button } from "semantic-ui-react";
import { getSecurityKey, getChatMessgaes, addChatMessages } from "../../features/tableData/visualSlice"
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import TableVisualise from "./TableVisualise";
import './PlayData.css';
import { getDatabases } from "../../features/tableData/visualSlice";
import { examples_data } from "../../data/examples";

// const options = [
//   { key: 'Database', text: 'Database', value: 'Database' },
//   { key: 'Active Table', text: 'Active Table', value: 'Active Table' },
// ]

export default function PlayData() {

    // const [messages, setMessages] = useState([]);

    const messages = useSelector(getChatMessgaes);
   
    const [value, setValue] = useState("");
    const [disabled, setDisabled] = useState(false);
    // const [iconName, setIconName] = useState("chat")
    const dispatch = useDispatch();
    const securityKey = useSelector(getSecurityKey);
    const [examples, setExamples] = useState(true);
    const bottomRef = useRef(null);

    const [showModal, setShowModal] = useState(false);
    const [currentData, setCurrentData] = useState();

    // const tableData = useSelector(getTableData);

    // const [queryType, setQueryType] = useState("Database");
    const databases = useSelector(getDatabases);
  
    useEffect(() => {
      // 👇️ scroll to bottom every time messages change
      bottomRef.current?.scrollIntoView({behavior: 'smooth'});
  }, [messages]);

    const handleChange = (e) => {
        setValue(e.target.value);
    };
  
    const handleSubmit = () => {
      setDisabled(true);
      // setIconName("spinner");
      setExamples(false);
      // var newMesages = [...messages, {"question": value}];
      dispatch(addChatMessages({"question": value}));
      // setMessages([...messages, {"question": value}]);
      
      const promise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/fetch_and_run_query`, {params : {securityKey: securityKey, dbName: databases[0].name, question: value, queryType: "new"}});
      promise.then((response) => {
          console.log(response.data);
          // dispatch(setTableData(response.data));
          dispatch(addChatMessages({"answer": response.data}));
          // setMessages([...newMesages, {"answer": response.data.tableData.comment}]);
          setValue("");
          setDisabled(false);
          // setIconName("chat");
          if(!response.data.error) {
            showTableVisualiseModal(response.data);
          }
        },
        (error) => {
          console.log(error);
          setValue("");
          setDisabled(false);
          // setIconName("chat"); 
        }
      );
    };
  
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
          handleSubmit();
      }
    }

    const showTableVisualiseModal = (element) => {
        console.log(showModal);
        setCurrentData(element);
        setShowModal(true);
    }

    const closeModal = () => {
      console.log("inside close");
      setShowModal(false);
    };
    
    // const handleDropDown = (event, { value }) => {
    //   // console.log(value);
    //   setQueryType(value);
    // }
  console.log(databases[0].name);
  
  return (
    <>
    <Grid>
        <Grid.Row>
          {/* <div style={{height: "85vh", overflow: "scroll"}}>

          </div> */}
        </Grid.Row>
        <Grid.Row columns={1}>
         <Grid.Column width={16}>
          <div className="qa_container">
            <div className="qa_container_inner">
              {messages.length === 0 && 
                <>
                  <Grid>
                    <Grid.Row columns={3}>
                      <Grid.Column width={3}>
                      </Grid.Column>
                      <Grid.Column width={10}>
                        <Button fluid onClick={() => {setExamples(!examples)}} className="top_margin">Some examples to start with</Button>
                        {
                          examples && 
                            examples_data[databases[0].name].map((example, index) => {
                              return (
                                <Segment inverted className="wrap_message examples">
                                  {example}
                                </Segment>
                              );
                            })
                        }
                        {/* {securityKey !== 'corvus' && examples &&  
                          <>
                            
                            <Segment inverted className="wrap_message examples">
                              What is the total sales by region in the month of January
                            </Segment>
                            <Segment inverted className="wrap_message examples">
                              What is the monthly trend of orders
                            </Segment>
                            <Segment inverted className="wrap_message examples">
                              Give me the GMV for 2022
                            </Segment>
                            <Segment inverted className="wrap_message examples">
                              Give me GMV by region for 2022
                            </Segment>
                            <Segment inverted className="wrap_message examples">
                              What is the total revenue lost due to failed payments
                            </Segment>
                          </>
                      }
                      {securityKey === 'corvus' && examples &&  
                          <>
                            <Segment inverted className="wrap_message examples">
                            How many sku's moved locations and how many times?
                            </Segment>
                            <Segment inverted className="wrap_message examples">
                            Give me the maximum quantity of every sku
                            </Segment>
                            <Segment inverted className="wrap_message examples">
                            Show the oldest instance of every sku
                            </Segment>
                          </>
                      } */}
                      </Grid.Column>
                      <Grid.Column width={3}>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </>
              }
              {messages.length > 0 &&
                <>
                  {
                    messages.map((element, index) => {
                      
                        if(element.answer === undefined) {
                          return (
                            <Segment inverted className="wrap_message question">
                            {/* <Input> */}
                            {element.question}
                            {/* </Input> */}
                            </Segment>
                          );
                        } else {
                          const answerlis = element.answer.displayInfo.comment.split('\n');
                          return (
                            <Segment inverted className="wrap_message answer" >
                              {
                                answerlis.map((x) => {
                                  return (
                                    <>
                                      <p>{x}</p>
                                    </>
                                  );
                                })
                              }
                              {!element.answer.error && <a href="#!" onClick={() => {showTableVisualiseModal(element.answer)}}> <b>Click here to view data</b></a>}
                            </Segment>
                          );
                        }  
                    })
                  }
                  {disabled && <Segment inverted className="wrap_message answer" > <Icon name="spinner" loading size="large"/> </Segment>}
                </>
              }
              <div ref={bottomRef}></div>
          </div>
            <Input className="query_input" fluid iconPosition="left" icon={<Icon name="chat" link 
                onClick={handleSubmit}/>} onChange={handleChange} value={value} disabled={disabled} onKeyDown={handleKeyDown} 
              placeholder="Ask your query"/>
              {/* labelPosition="right"
              label={<Dropdown options={options} onChange={handleDropDown} value={queryType} />}/> */}
          </div>
          </Grid.Column>
          {/* <Grid.Column width={9}>
            <div className="table_container">
            {tableData.tableData !== undefined && tableData.tableData.query.length !== 0 && <Transform headers={tableData.tableData.headers} data={tableData.tableData.data}/>}
            </div>
          </Grid.Column> */}
        </Grid.Row>
        {/* <Grid.Row columns={1}>
            <Grid.Column width={16}>
        {tableData.tableData !== undefined && <Transform headers={tableData.tableData.headers} data={tableData.tableData.data}/>}
        </Grid.Column>
        </Grid.Row> */}
    </Grid>
    {showModal && <TableVisualise closeModal={closeModal} currentData={currentData}/>}
     </>
  );
}
